import { LayoutHome } from "@/components/layouts/LayoutHome";
import EventoController from "@/controllers/EventoController";
import { EventoModel } from "@/models/EventoModel";
import { LoteModel } from "@/models/LoteModel";
import ApiHelper, { ResponseProps } from "@/shared/ApiHelper";
import utils from "@/shared/utils";
import FacebookPixel from '@/components/FacebookPixel';

import {
  Accordion,
  Button,
  Label,
  Modal,
  Tabs,
  TextInput,
  Alert,
} from "flowbite-react";
import { GetServerSideProps, NextApiRequest } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import MapaGoogle from "@/components/MapaGoogle";
import YouTubeView from "@/components/YouTubeView";
import { AreaModel } from "@/models/AreaModel";
import { MesaModel } from "@/models/MesaModel";
import { getSession, useSession } from "next-auth/react";
import { toast } from "react-toastify";
import { BsClock, BsClockFill, BsHourglass } from "react-icons/bs";
import { FaMapMarkerAlt, FaMapPin } from "react-icons/fa";
import { RiEarthFill, RiWhatsappFill } from "react-icons/ri";
import { HiClock, HiInformationCircle } from "react-icons/hi";
import HtmlContent from "@/components/HtmlContent";
import * as _ from "lodash";
import moment from "moment-timezone";
import toastCustom from "@/shared/toastCustom";
import {
  ArrowRightIcon,
  LockClosedIcon,
  PlusIcon,
} from "@heroicons/react/24/solid";
import { GoTriangleRight } from "react-icons/go";
import { BiPlusMedical } from "react-icons/bi";
import { ImMinus } from "react-icons/im";
import { VscChromeClose } from "react-icons/vsc";
import ModalFull from "@/components/ModalFull";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import AccordionComponent from "@/components/AccordionComponent";
import PixelGoogle from "@/components/PixelGoogle";
import ShareButton from "@/components/ShareButton";
import AjudaBotao from "@/components/AjudaBotao";
import useScreenSize from "@/components/TamanhoDaTela";
import CartFooterComponent from "@/components/compra/CartFooter";
import SpinnerComponent from "@/components/utils/SpinnerComponent";
import { CartModelProps } from "../checkout/cart";

interface EventoProps {
  evento: EventoModel;
  lotes: LoteModel[];
  cookie_id: string;
  permiteCupom: false;
  dadosCart: CartProps;
  notFound: false;
  error?: string
}

export type CartProps = {
  qtdCart: string;
  totalCart: string;
  mesasCart: string[];
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const id = context.query.id;

  let evento: any;
  const lotes: LoteModel[] = [];
  let cookie_id = context?.req?.cookies.cart || 0;
  var permiteCupom = false;
  const session = await getSession(context);
  let dadosCart: any;
  let notFound = false;

  try {
    const res = await ApiHelper.post({
      url: ApiHelper.eventosPorId,
      method: "POST",
      timezone: context.req.cookies.timezone,
      data: {
        id,
      },
    });

    if (res.response) {
      evento = res.dados;

      permiteCupom =
        evento.areas.filter((o: AreaModel) => o.cupom_desconto === true)
          .length > 0;

      evento?.lotes?.forEach((item: LoteModel) => {
        const area = evento.areas.filter(
          (o: AreaModel) => o.id == item.area_id
        );

        const objLote: LoteModel = {
          lote_id: item.id,
          area_id: item.area_id,
          nome: item.nome,
          titulo: item.titulo,
          quantidade: 0,
          valor: item.valor ?? 0,
          subtotal: 0,
          evento_id: evento.id,
          cupom_desconto: area.length ? area[0].cupom_desconto : "",
        };

        lotes.push(objLote);
      });
      const arrAreas: any[] = [];
      evento.areas?.forEach((area: AreaModel) => {
        const filter = lotes.filter((o: any) => o.area_id == area.id);
        if (filter.length > 0) arrAreas.push(area);
      });

      evento.areas = arrAreas;
    }

    const resCarts = await EventoController.getCart({
      user_id: session?.user.sub,
      cookie_id,
    });

    if (resCarts.dados) {
      dadosCart = utils.setQtdCartCookie(resCarts.dados, false);
      if (resCarts.dados.length === 0) {
        cookie_id = utils.setCookieCart(utils.randomNumber(), true);
        utils.setQtdCartCookie([]);
      }
    }
  } catch (e: any) {
    notFound = true;

    return {
      props: {
        evento: {},
        lotes,
        cookie_id,
        permiteCupom,
        dadosCart: null,
        notFound,
      },
    };
  }

  return {
    props: { evento, lotes, cookie_id, permiteCupom, dadosCart, notFound },
  };
};

export default function EventoDetail(props: EventoProps) {
  const router = useRouter();
  const { data: session } = useSession();
  const [notFound, setNotFound] = useState(props.notFound);
  const tamanhoDaTela = useScreenSize();
  const lotesRef = useRef(new Array());
  const [toastShown, setToastShown] = useState(false);

  const { evento } = props;

  const [areas, setAreas] = useState(evento?.areas ?? []);
  const [cookie_id, setCookieId] = useState(props.cookie_id);
  utils.setCookieCart(cookie_id, true);

  const [areaSelecionada, setAreaSelecionada] = useState<AreaModel>();
  const [lotes, setLotes] = useState<LoteModel[]>(props.lotes);
  const [total, setTotal] = useState(0);

  const [eventoDisponivel, setEventoDisponivel] = useState(false);

  const [verMapaModal, setVerMapaModal] = useState(false);
  const [loteSelecionado, setLoteSelecionado] = useState<LoteModel>();
  const [mesas, setMesas] = useState<MesaModel[]>([]);
  const [qtdCart, setQtdCart] = useState<any>(props.dadosCart?.qtdCart ?? "0");
  const [totalCartView, setTotalCartVIew] = useState(
    props.dadosCart?.totalCart ?? "0"
  );
  const [showModalFull, setShowModalFull] = useState(false);
  const [showVideo, setShowVideo] = useState("");
  const [spinnerMesa, setSpinnerMesa] = useState(false);
  const [showModalCapa, setShowModalCapa] = useState(false);
  const [imgCapaArea, setImgCapaArea] = useState("");
  const [cupom, setCupom] = useState("");
  const [escolherMapa, setEscolherMapa] = useState(false);
  const [spinner, setSpinner] = useState(false);
  let mesasCookie = props.dadosCart?.mesasCart ?? [];

  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const validarEventoDisponivel = () => {
    if (notFound && !toastShown) {
      toast.dismiss();
      toast("Evento não disponível!", {
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setToastShown(true);
      router.push("/");
    }
  };

  useEffect(() => {
    utils.removeCookie("cupom");

    if (areas.length) {
      setAreaSelecionada(areas[0]);
    }

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Para obter o tamanho inicial
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (notFound && !toastShown) {
      validarEventoDisponivel();
    }
    validaSeDataParaInicioDeVendas();
  }, [toastShown]);

  const monitorCart = async () => {
    try {
      const res = await EventoController.getCart({
        user_id: session?.user.sub,
        cookie_id,
      });
      if (res.response) {
        const qtdCart = String(res.dados.length);
        if (res.dados.length === 0) {
          const new_cookie_id = utils.setCookieCart(utils.randomNumber(), true);
          setCookieId(new_cookie_id);
          utils.setQtdCartCookie([]);
        }
        setQtdCart(qtdCart);
      }
    } catch (e) {
      console.log("###", e);
    }
  };

  const validaSeDataParaInicioDeVendas = () => {
    if (evento.data_para_venda === "") {
      return setEventoDisponivel(true);
    }

    const dataFormat = moment(evento.data_para_venda, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );

    const data =
      evento.data_para_venda === ""
        ? ""
        : `${dataFormat}T${evento.hora_para_venda}`;

    // Verificar se a data é vazia
    if (!data) {
      return setEventoDisponivel(true);
    }

    // Obter a data de hoje
    const hoje = moment();

    // Converter a string de data para um objeto moment
    const dataMoment = moment(data);

    // Verificar se a data é válida
    if (!dataMoment.isValid()) {
      return setEventoDisponivel(true);
    }

    // Comparar a data com a data de hoje
    if (dataMoment.isBefore(hoje)) {
      return setEventoDisponivel(true);
    } else {
      return setEventoDisponivel(false);
    }

    setEventoDisponivel(true);
  };

  const calculaTotal = () => {
    const cupomObj = utils.getCookie("cupom");
    let cupomJson = null;

    if (cupomObj) {
      cupomJson = JSON.parse(cupomObj);
    }

    let somaTotal = 0;
    let cupomDescontoValor = 0;

    if (cupomJson) {
      cupomDescontoValor = cupomJson.desconto / 100;
    }

    let qtdItens = 0;

    lotes.forEach((item: any) => {
      if (item.quantidade && item.quantidade > 0) {
        qtdItens += item.quantidade;
        var subtotal = item?.subtotal ?? 0;

        if (item.cupom_desconto == true) {
          subtotal = Math.ceil(subtotal - subtotal * cupomDescontoValor);
        }
        somaTotal = somaTotal + (subtotal ?? 0);
      }
    });

    setTotalCartVIew(String(somaTotal));

    return somaTotal;
  };

  const setQuantidade = async (id: number, somar: boolean) => {
    setLotes([]);
    setTotal(0);
    const arr = lotes;
    let qtdCartVar = utils.getQtdCartCookie();
    let totalCartVar = utils.getCookie(utils.totalCart);
    totalCartVar = totalCartVar != "" ? totalCartVar : "0";

    arr.forEach((item: any) => {
      item.cookie_id = cookie_id;

      if (item.lote_id == id) {
        if (somar) {
          item.quantidade = item.quantidade != null ? item.quantidade + 1 : 0;
          const somaCart = parseInt(qtdCartVar) + 1;
          //utils.setCookie(utils.qtdCart, somaCart.toString())
        } else {
          const calc = item.quantidade != null ? item.quantidade - 1 : 0;

          if (calc >= 0) {
            item.quantidade = calc;

            const somaCart = parseInt(qtdCartVar) - 1;
            //utils.setCookie(utils.qtdCart, somaCart.toString())
          }
        }

        var calcCart = 0;
        const valorTotalCart = parseInt(totalCartVar);

        if (somar) {
          calcCart = valorTotalCart + (item.valor ?? 0);
        } else {
          calcCart =
            valorTotalCart > 0 ? valorTotalCart - (item.valor ?? 0) : 0;
        }

        //utils.setCookie(utils.totalCart, calcCart.toString())
      }
      item.subtotal = 0;
      if (item.quantidade && item.valor) {
        item.subtotal = item.quantidade * item.valor;
      }
    });

    //setQtdCart(utils.getQtdCartCookie())
    //setTotalCartVIew(utils.getCookie(utils.totalCart))

    const resCarts = await EventoController.getCart({
      user_id: session?.user.sub,
      cookie_id,
    });

    if (resCarts.response) {
      const dados = utils.setQtdCartCookie(resCarts.dados, false);
      setQtdCart(dados.qtdCart);
      setTotalCartVIew(dados.totalCart);
      mesasCookie = dados.mesasCart;
    }

    setTimeout(() => {
      setLotes(arr);
      setTotal(calculaTotal());
    }, 1);
  };

  const irParaCheckout = (reservar: boolean) => {
    router.push(reservar ? "/checkout/reserve" : "/checkout/cart");
  };

  const cart = async (reservar: boolean, addItem: boolean) => {
    const compras: any[] = [];
    let passa = true;

    lotes.forEach((item: any) => {
      if (item.quantidade && item.quantidade > 0) {
        let stringIdsMesas = "";

        const a = areas?.filter((a: any) => a.id == item.area_id);

        if (
          a != null &&
          a[0].nomeclatura != "individual" &&
          item.mesas == undefined
        ) {
          toastCustom.show({
            mensagem:
              "Escolha " + a[0].nomeclatura + " para o lote selecionado",
            type: "warning",
          });

          passa = false;
          return;
        }

        if (item.mesas && item.mesas?.length < item.quantidade) {
          const diferenca = item.quantidade - item.mesas?.length;

          toast(
            `Escolha mais ${diferenca} ${
              a && a[0].nomeclatura
            } para o lote selecionado`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );

          passa = false;
          return;
        }

        item.mesas?.forEach((mesa: any) => {
          if (stringIdsMesas == "") {
            stringIdsMesas = ";" + mesa.id;
          } else {
            stringIdsMesas = stringIdsMesas + ";" + mesa.id;
          }
        });

        const obj = {
          area_id: item.area_id,
          cookie_id: item.cookie_id,
          user_id: !reservar ? session?.user.sub : null,
          evento_id: item.evento_id,
          lote_id: item.lote_id,
          nome: item.nome,
          quantidade: item.quantidade,
          subtotal: item.subtotal,
          valor: item.valor,
          ingressos: stringIdsMesas != "" ? stringIdsMesas + ";" : null,
        };

        compras.push(obj);
      }
    });

    if (!passa) return;

    try {
      if (compras.length == 0) {
        toastCustom.show({
          mensagem: "Selecione um ingresso para continuar.",
          type: "warning",
        });
        return;
      }

      const res = await EventoController.addItemCart({
        user_id: !reservar ? session?.user.sub : null,
        cupom: cupom,
        evento_id: evento.id,
        carts: compras,
        addItem: addItem,
      });

      return res;
    } catch (e: any) {
      toastCustom.show({
        mensagem: e.message,
        type: "error",
      });
    }
  };

  const addItemNoCart = async (
    lote: LoteModel,
    somar: boolean,
    mesa?: MesaModel
  ): Promise<ResponseProps> => {
    try {
      if (lote.quantidade == 0 && !somar) {
        return { response: false, dados: null, message: "Falha", status: 404 };
      }

      var stringIdsMesas = "";

      if (mesa) {
        const mesaList = [mesa];

        mesaList?.forEach((mesa: any) => {
          if (stringIdsMesas == "") {
            stringIdsMesas = ";" + mesa.id;
          } else {
            stringIdsMesas = stringIdsMesas + ";" + mesa.id;
          }
        });
      }

      let cupomId = null;
      let cupom = null;
      if (areaSelecionada?.cupom_desconto) {
        const cupomObj = utils.getCookie("cupom");
        let cupomJson = null;

        if (cupomObj) {
          cupomJson = JSON.parse(cupomObj);
          cupomId = cupomJson.id;
          cupom = cupomJson.cupom;
        }
      }

      const obj = {
        cookie_id: cookie_id,
        user_id: session?.user.sub,
        lote_id: lote.lote_id,
        ingressos: stringIdsMesas != "" ? stringIdsMesas + ";" : null,
        somar,
        cupom_id: cupomId,
        cupom,
      };

      setSpinner(true);
      const res = await EventoController.addItemCart(obj);
      setSpinner(false);

      if (res.response) {
        setQuantidade(lote?.lote_id ?? 0, somar);
      } else {
        toastCustom.show({
          type: "warning",
          mensagem: res.message,
        });
      }
      return res;
    } catch (e: any) {
      setSpinner(false);
      toastCustom.show({
        type: "warning",
        mensagem: e.message,
      });

      return { response: false, dados: null, message: e.message, status: 404 };
    }
  };

  const comprarAgora = () => {
    router.push("/checkout/cart");
  };

  const temVideo = evento.video_url != undefined && evento.video_url != "";

  const escolherMesa = async (lote: LoteModel, area?: AreaModel) => {
    setSpinnerMesa(true);
    const res = await EventoController.getIngressos(
      lote?.lote_id ?? 0,
      null,
      session?.user.sub
    );

    if (res.response) {
      res.dados.forEach((item: any) => {
        item.selecionada = false;
      });
      setMesas(_.orderBy(res.dados, "id", "asc"));
    }

    setLoteSelecionado(lote);
    setAreaSelecionada(area);
    setVerMapaModal(true);
    setSpinnerMesa(false);
  };

  const temMesaCookie = (id?: number): boolean => {
    var saida = false;
    var temMesaLocal = false;

    lotes.forEach((lote: any) => {
      if (lote.mesas) {
        const arrTem = lote.mesas.filter((o: any) => o.id == id);
        temMesaLocal = arrTem.length > 0;
      }
    });

    const temCookie = mesasCookie.filter((o: string) => parseInt(o) == id);

    if (temCookie.length > 0 && !temMesaLocal) {
      saida = true;
      toastCustom.show({
        type: "warning",
        mensagem: "Está mesa já foi adicionada no carrinho.",
      });
    }

    return saida;
  };

  const selecionarMesa = async (mesa: MesaModel) => {
    if (mesa.status !== "liberado") return;
    if (temMesaCookie(mesa.id)) return;

    setLotes([]);
    const lotesArr = lotes;
    let mesasArr = mesas;

    await utils.asyncForEach(lotesArr, async (lote: LoteModel) => {
      let jaTemMesa = false;

      lote.mesas?.forEach((mesaItem: any) => {
        if (mesaItem.id == mesa.id) {
          jaTemMesa = true;
        }
      });

      if (!jaTemMesa) {
        if (lote.lote_id == loteSelecionado?.lote_id) {
          if (lote.mesas == undefined) {
            lote.mesas = [mesa];
          } else {
            lote?.mesas.push(mesa);
          }

          const res = await addItemNoCart(lote, true, mesa);
          if (res.response) {
            mesasArr.forEach((item: any) => {
              if (item.id == mesa.id) {
                item.selecionada = true;
              }
            });
          } else {
            mesasArr.forEach((item: any) => {
              if (item.id == mesa.id) {
                item.selecionada = false;
                lote.mesas = utils.removeObjeto(lote.mesas, "id", mesa.id);
              }
            });
          }
        }
      } else {
        const res = await addItemNoCart(lote, false, mesa);
        if (res.response) {
          lote.mesas = utils.removeObjeto(lote.mesas, "id", mesa.id);
        }
      }
    });

    setTimeout(() => {
      setLotes(lotesArr);
      setMesas(mesasArr);
    }, 10);
  };

  const removerMesas = () => {
    const arr = lotes;

    utils.asyncForEach(arr, async (item) => {
      if (item.lote_id == loteSelecionado?.lote_id) {
        await utils.asyncForEach(item.mesas, async (mesa) => {
          await addItemNoCart(item, false, mesa);
        });

        item.mesas = [];
        item.quantidade = 0;
        item.subtotal = 0;
      }
    });

    setLotes(arr);
    setTotal(calculaTotal());
  };

  const verificaMesaSelecionada = (mesaId: number) => {
    let tem = false;

    lotes.forEach((lote: any) => {
      lote.mesas?.forEach((mesa: any) => {
        if (mesa.id == mesaId) {
          tem = true;
        }
      });
    });
    return tem;
  };

  const mesaMapa = (mesa: MesaModel) => {
    let cor = "";
    let selecionado = false;

    if (mesa.status == "liberado") {
      cor = "bg-green-500";
    } else if (mesa.status == "reservado") {
      cor = "bg-gray-500";
    } else if (mesa.status == "vendido") {
      cor = "bg-red-500";
    }

    lotes.forEach((lote: any) => {
      lote.mesas?.forEach((mesaItem: any) => {
        if (mesaItem.id == mesa.id) {
          selecionado = true;
        }
      });
    });

    if (selecionado) {
      cor = "bg-green-800";
    }

    return (
      <div
        key={`mesa-${mesa.id}`}
        onClick={() => selecionarMesa(mesa)}
        className={`${cor} circulo-mesa w-8 h-8`}
      >
        {_.padStart(mesa.nome, 2, "0")}
      </div>
    );
  };

  const aplicarDesconto = async () => {
    try {
      const res = await EventoController.getCupom(cupom);

      if (res.response) {
        if (res.dados.evento_id != evento.id) {
          toastCustom.show({
            mensagem: "Cupom inválido para este evento.",
            type: "warning",
          });
        } else {
          utils.setCookie("cupom", JSON.stringify(res.dados));

          setTotal(calculaTotal());
          toastCustom.show({
            mensagem: "Código promocional aplicado com sucesso.",
            type: "success",
          });
        }
      } else {
        toastCustom.show({
          mensagem: "Cupom não encontrado",
          type: "warning",
        });
      }
    } catch (e: any) {
      toastCustom.show({
        mensagem: e.message,
        type: "error",
      });
    }

    try {
      const resCarts = await EventoController.getCart({
        user_id: session?.user.sub,
        cookie_id,
      });

      if (!resCarts.dados) return;

      for (const card of resCarts.dados) {
        const lote = {
          quantidade: card.quantidade,
          lote_id: card.lote.id,
        };
        await addItemNoCart(lote ?? 0, false);
      }

      for (const card of resCarts.dados) {
        const lote = {
          quantidade: card.quantidade,
          lote_id: card.lote.id,
        };
        await addItemNoCart(lote ?? 0, true);
      }
    } catch (e: any) {
      toastCustom.show({
        mensagem: e.message,
        type: "error",
      });
    }
  };

  const addCupom = async (valor: string) => {
    if (valor == "") {
      utils.removeCookie("cupom");
      setTotal(calculaTotal());
    }

    setCupom(valor);
  };

  const shareData = {
    title: evento.nome,
    text: evento.diaPorExtenso,
    url: "http://industriadoingresso.com.br" + router.asPath,
  };

  const mostrarCapaArea = (img: string) => {
    setImgCapaArea(img);
    setShowModalCapa(true);
  };

  const escolherMapaFunction = () => {
    if (areaSelecionada?.video_mapa) {
      setEscolherMapa(true);
    } else {
      mostrarCapaArea(evento.mapa);
    }
  };

  const mostrarVideo = (url?: string) => {
    if (url) {
      setShowVideo(url);
      setShowModalFull(true);
    }
  };

  return (
    <>
      {props.evento.pixel_facebook !== '' && (
         <FacebookPixel pixelId={props.evento.pixel_facebook ?? ""} />
      )}
      {evento.id && (
        <>
          <SpinnerComponent show={spinner} />
          <AjudaBotao
            numero={
              evento.promotor != null &&
              evento.promotor?.telefone_comercial != null &&
              evento.promotor?.telefone_comercial != ""
                ? `${utils.somenteNumeros(evento.promotor?.telefone_comercial)}`
                : ""
            }
          />
          {totalCartView !== "0" && (
            <CartFooterComponent qtdCart={qtdCart} total={totalCartView} />
          )}
          <LayoutHome marginBotton={60} qtdCart={qtdCart}>
            <div className="md:container mx-auto py-5 grid md:grid-cols-3 sm:px-10 mb-10">
              <div className="py-5 px-2 ">
                <img src={evento.capa} alt="" className="rounded-md" />
                <div className="bg-gray-100 border-gray-200 border p-8 rounded mt-10">
                  <p>
                    <strong>PRODUTOR: </strong> {evento.promotor?.razao}
                  </p>

                  {evento.promotor?.cnpj && (
                    <p>
                      <strong>CNPJ: </strong> {evento.promotor?.cnpj}
                    </p>
                  )}

                  {evento.promotor?.cpf && (
                    <p>
                      <strong>CPF: </strong> {evento.promotor?.cpf}
                    </p>
                  )}

                  {evento.publico != undefined &&
                    evento.publico != null &&
                    evento.publico > 0 && (
                      <p key="publicoAlvo">
                        <strong>PÚBLICO ESPERADO: </strong> {evento.publico}
                      </p>
                    )}

                  {evento.promotor?.telefone_comercial !== "" && (
                    <p>
                      <strong>WHATSAPP: </strong>
                      <Link
                        className="text-blue-500"
                        href={`https://wa.me/55${utils.somenteNumeros(
                          evento.promotor?.telefone_comercial
                        )}?text=Ol%C3%A1%2C+vim+pelo+ind%C3%BAstriadoingresso.com+e+preciso+de+ajuda.`}
                        target="_blank"
                      >
                        {evento.promotor?.telefone_comercial}
                      </Link>
                    </p>
                  )}

                  {evento?.promotor?.instagram !== "" && (
                    <p key="instaPromotor">
                      <strong>INSTAGRAM: </strong>
                      <Link
                        className="text-blue-500"
                        href={`https://instagram.com/${evento?.promotor?.instagram}`}
                        target="_blank"
                      >
                        @{evento?.promotor?.instagram ?? ""}
                      </Link>
                    </p>
                  )}
                </div>
              </div>
              <div className=" sm:px-5 md:col-span-2 flex flex-col">
                <div className="pt-4 ">
                  <p className="text-4xl font-bold mb-2 ml-2 text-myblue text-center md:text-left">
                    {evento.nome}
                  </p>
                  <hr />

                  <div className="grid md:grid-cols-2">
                    <div>
                      <div className="text-sm ml-2">
                        <p className="pt-5 flex items-center">
                          <HiClock className="mr-2 text-myred" />{" "}
                          {evento.diaPorExtenso} - {evento.horaInicio}h
                        </p>
                        <p className="flex items-center">
                          <FaMapMarkerAlt className="mr-2 text-myred" />{" "}
                          {evento.local}
                        </p>
                        <p className="flex items-center">
                          <RiEarthFill className="mr-2 text-myred" />{" "}
                          {evento.cidade}-{evento.estado}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="h-9  bg-red-700 mx-2 rounded text-center text-white flex items-center justify-center font-bold mt-10">
                  INGRESSOS
                </div>

                {eventoDisponivel === true && (
                  <div>
                    <ul className="grid lg:grid-cols-5 grid-cols-3 gap-2 text-xs m-2">
                      {areas?.map((area) => (
                        <li
                          key={`li-${area.id}`}
                          onClick={() => {
                            setAreaSelecionada(area);
                          }}
                          className={`p-2 border-2 font-semibold rounded-md cursor-pointer flex items-center justify-center text-center`}
                        >
                          {area.nome}

                          <style jsx>{`
                            li {
                              border-color: ${area.cor};
                              color: ${areaSelecionada?.id === area.id
                                ? "white"
                                : area.cor};
                              background-color: ${areaSelecionada?.id ===
                              area.id
                                ? area.cor
                                : ""};
                            }
                            li:hover {
                              background-color: ${area.cor};
                              color: white;
                            }
                          `}</style>
                        </li>
                      ))}
                    </ul>

                    {areaSelecionada?.acesso != null &&
                      areaSelecionada.acesso != "" && (
                        <>
                          <div className="gap-3 p-3 bg-orange-100 rounded-md mt-5 mx-2">
                            <div
                              className="text-justify text-orange-800"
                              style={{ fontSize: "13px" }}
                            >
                              {areaSelecionada?.acesso}
                            </div>
                            <div className="flex justify-start gap-3 w-full mt-2">
                              {evento.mapa != null && evento.mapa != "" && (
                                <>
                                  <Button
                                    className="md:w-52"
                                    size="sm"
                                    color="warning"
                                    onClick={() => {
                                      escolherMapaFunction();
                                    }}
                                  >
                                    VER MAPA
                                  </Button>
                                </>
                              )}
                              {areaSelecionada.video != null &&
                                areaSelecionada.video != "" && (
                                  <>
                                    <Button
                                      className="md:w-52"
                                      size="sm"
                                      color="warning"
                                      onClick={() => {
                                        mostrarVideo(areaSelecionada.video);
                                      }}
                                    >
                                      VÍDEO EXPLICATIVO
                                    </Button>
                                  </>
                                )}
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                )}
                <div className="mt-7 border rounded-lg md:p-5 p-2 mx-2">
                  {eventoDisponivel === true && (
                    <div>
                      {areaSelecionada?.esgotar && (
                        <div className="text-sm text-white bg-red-600 p-3 rounded-md uppercase font-bold text-center">
                          Os ingressos para {areaSelecionada.nome} ESTÃO INDISPONÍVEIS!
                        </div>
                      )}

                      {lotes
                        .filter(
                          (o) =>
                            o.area_id == areaSelecionada?.id &&
                            !areaSelecionada?.esgotar
                        )
                        .map((lote, index) => (
                          <div
                            key={`area-lote-${lote.lote_id}`}
                            className="border-b-2 border-gray-100 pb-3 text-sm"
                            ref={(element) => lotesRef.current.push(element)}
                          >
                            <div className="grid grid-cols-1 lg:grid-cols-2 items-center justify-between pt-2 ">
                              <div className="text-md  w-full">
                                {lote.titulo && lote.titulo != "" && (
                                  <>
                                    <strong>Ingresso:&nbsp;</strong>{" "}
                                    {lote.titulo}
                                    <br></br>
                                  </>
                                )}
                                <strong>
                                  {areaSelecionada?.nome} - {lote.nome}
                                </strong>
                                {evento.censura != undefined && (
                                  <span key={`censuraSpan`} className="text-xs">
                                    {" "}
                                    - CLASSIFICAÇÃO {evento?.censura}+
                                  </span>
                                )}
                              </div>
                              <div className="w-full mt-2 ">
                                <div className="w-full flex justify-between items-center">
                                  {areaSelecionada?.nomeclatura ==
                                    "individual" && (
                                    <div className="grid grid-cols-3 items-center">
                                      <div>
                                        <div
                                          onClick={() =>
                                            addItemNoCart(lote ?? 0, false)
                                          }
                                          className="btn-qtd bg-gray-300 "
                                        >
                                          <ImMinus className="text-gray-500" />
                                        </div>
                                      </div>
                                      <div className="flex justify-center items-center ">
                                        {lote.quantidade}
                                      </div>
                                      <div>
                                        <div
                                          onClick={() =>
                                            addItemNoCart(lote ?? 0, true)
                                          }
                                          className="btn-qtd bg-blue-700"
                                        >
                                          <BiPlusMedical className="text-white" />
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {areaSelecionada?.nomeclatura !=
                                    "individual" && (
                                    <div className="flex justify-end col-span-2">
                                      <Button
                                        size="xs"
                                        className="border-2"
                                        color="light"
                                        onClick={() => {
                                          escolherMesa(lote, areaSelecionada);
                                        }}
                                        style={{
                                          borderColor: areaSelecionada?.cor,
                                          color: areaSelecionada?.cor,
                                        }}
                                      >
                                        {spinnerMesa
                                          ? "BUSCANDO.."
                                          : `ESCOLHER ${
                                              areaSelecionada?.nome?.split(
                                                " "
                                              )[0]
                                            }`}
                                      </Button>
                                    </div>
                                  )}

                                  <div className="text-center">
                                    <strong className="text-lg">
                                      {utils.currencyRegex(
                                        lote.valor?.toString() ?? "",
                                        true
                                      )}
                                    </strong>{" "}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div>
                              {areaSelecionada?.nomeclatura != "individual" && (
                                <div
                                  key={`area-mesa-${areaSelecionada?.id}`}
                                  className="grid grid-cols-5 mt-5"
                                >
                                  <div className="col-span-3">
                                    <div className="w-full">
                                      <div className="text-gray-500 text-sm">
                                        Mesas/Assentos:
                                      </div>
                                      <div className="flex gap-4 w-full md:ml-2">
                                        {_.orderBy(
                                          lote.mesas,
                                          "id",
                                          "asc"
                                        )?.map((mesa) => (
                                          <div
                                            key={`mesa-${mesa.id}`}
                                            className="circulo-mesa bg-green-500 w-12 h-12"
                                          >
                                            {_.padStart(mesa.nome, 2, "0")}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                  {eventoDisponivel === false &&
                    evento.data_para_venda !== "" && (
                      <Alert color="failure" icon={HiInformationCircle}>
                        Vendas liberadas a partir de{" "}
                        {moment(evento.data_para_venda, "DD-MM-YYYY").format(
                          "DD/MM/YYYY"
                        )}{" "}
                      {evento.hora_para_venda}{" "}
                      </Alert>
                    )}
                </div>

                {props.permiteCupom && (
                  <>
                    {areaSelecionada?.cupom_desconto != true &&
                      props.permiteCupom &&
                      !areaSelecionada?.esgotar && (
                        <>
                          <div className="xl:flex justify-between items-center mt-5 mx-2 gap-3 border rounded-md p-5">
                            <div className="text-sm text-orange-400">
                              Esta área não aceita cupom de desconto
                            </div>
                          </div>
                        </>
                      )}
                    {areaSelecionada?.cupom_desconto && (
                      <>
                        <div className="xl:flex justify-between items-center mt-5 mx-2 gap-3 border rounded-md p-5">
                          <div className="xl:w-64 text-sm xl:px-10">
                            CÓDIGO PROMOCIONAL
                          </div>
                          <div className="flex justify-between xl:w-2/3 gap-2">
                            <div className="xl:w-full w-2/3">
                              <TextInput
                                key="cupomdesconto-input"
                                id="cupomdesconto"
                                type="text"
                                value={cupom}
                                onChange={(e) => {
                                  addCupom(e.target.value);
                                }}
                                placeholder="Digite o código promocional.."
                                required={true}
                              />
                            </div>
                            <div className=" flex justify-end ">
                              <Button
                                className="bg-myred hover:bg-myred mr-0 w-40"
                                onClick={() => {
                                  aplicarDesconto();
                                }}
                              >
                                APLICAR
                              </Button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {total > 0 && (
                  <div className="xl:flex justify-between items-center mt-5 mx-2 gap-3 border rounded-md p-5">
                    <div className="text-2xl xl:px-10 text-center lg:text-left">
                      TOTAL:{" "}
                      <strong className="text-3xl">
                        {utils.currencyRegex(total.toString(), true)}
                      </strong>{" "}
                      <span className="text-lg"></span>
                    </div>
                    <div className="md:flex hidden lg:justify-end justify-center items-start gap-2 mt-5 lg:mt-0 w-auto lg:w-40">
                      <Button
                        className="hover:bg-myblue h-14"
                        onClick={() => {
                          irParaCheckout(false);
                        }}
                        size="sm"
                      >
                        COMPRAR AGORA
                      </Button>
                    </div>
                  </div>
                )}

                <div className="flex justify-between gap-3 items-center mt-14 mb-5 ml-2">
                  <div
                    className="w-full bg-gray-300 rounded"
                    style={{ height: "2px" }}
                  ></div>
                  <div>INFORMAÇÕES</div>
                  <div
                    className="w-full bg-gray-300 rounded"
                    style={{ height: "2px" }}
                  ></div>
                </div>

                <div className="border rounded-md ml-2">
                  {((evento.descricao && evento.descricao != "") ||
                    (evento.video_url && evento.video_url != "")) && (
                    <AccordionComponent
                      title="Detalhes"
                      border={true}
                      open={true}
                    >
                      <div
                        className={`md:p-10 ${
                          temVideo ? " gap-5" : "grid-cols-1"
                        }`}
                      >
                        <div>
                          {temVideo && (
                            <>
                              <div className="lg:w-2/3 m-auto">
                                <YouTubeView
                                  url={evento.video_url ?? ""}
                                  width="100%"
                                />
                              </div>
                            </>
                          )}
                        </div>
                        <div className="mt-20">
                          <HtmlContent content={evento.descricao} />
                        </div>
                      </div>
                    </AccordionComponent>
                  )}

                  {evento.descricao_areas && evento.descricao_areas != "" && (
                    <AccordionComponent title="Sobre as Áreas" border={true}>
                      <div className="md:p-10">
                        <HtmlContent content={evento.descricao_areas} />
                      </div>
                    </AccordionComponent>
                  )}

                  {evento.pdvs && evento.pdvs.length > 0 && (
                    <AccordionComponent title="Pontos de Vendas" border={true}>
                      <div className="md:p-10 p:5 grid md:grid-cols-2 gap-10 w-full ">
                        {evento.pdvs?.map((pdv) => (
                          <div key={`pdv${pdv.id}`} className="">
                            <div className="font-bold">{pdv.nome}</div>
                            <div className="text-sm text-gray-600">
                              {pdv.endereco?.cidade && (
                                <>
                                  <p key={`endereco-endereco${pdv.id}`}>
                                    {pdv.endereco?.rua}, {pdv.endereco?.numero}{" "}
                                    {pdv.endereco?.bairro}
                                  </p>
                                  <p key={`endereco-cidade${pdv.id}`}>
                                    {pdv.endereco?.cidade?.nome}-
                                    {pdv.endereco?.cidade?.estado.sigla}
                                  </p>
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionComponent>
                  )}

                  {evento.mapa && evento.mapa != "" && (
                    <AccordionComponent title="Mapa do Evento" border={true}>
                      <div className="flex justify-center py-10">
                        <img
                          className="lg:w-10/12 w-full rounded-md"
                          src={evento.mapa}
                          alt=""
                        />
                      </div>
                    </AccordionComponent>
                  )}

                  {evento.latitude && evento.latitude != "" && (
                    <AccordionComponent title="Localização" border={true}>
                      <MapaGoogle
                        width="100%"
                        height="500px"
                        center={{
                          lat: parseFloat(evento.latitude ?? "0"),
                          lng: parseFloat(evento.longitude ?? "0"),
                        }}
                        markers={[
                          {
                            lat: parseFloat(evento.latitude ?? "0"),
                            lng: parseFloat(evento.longitude ?? "0"),
                          },
                        ]}
                      />
                    </AccordionComponent>
                  )}
                </div>
              </div>
            </div>
            <Modal
              show={escolherMapa}
              onClose={() => setEscolherMapa(false)}
              size="sm"
            >
              <Modal.Header>Escolha o tipo de mapa</Modal.Header>
              <Modal.Body>
                <div className="flex justify-between gap-2">
                  <Button
                    color="gray"
                    className="w-full"
                    onClick={() => {
                      mostrarCapaArea(evento.mapa);
                      setEscolherMapa(false);
                    }}
                  >
                    Imagem
                  </Button>
                  <Button
                    color="gray"
                    className="w-full"
                    onClick={() => {
                      mostrarVideo(areaSelecionada?.video_mapa);
                      setEscolherMapa(false);
                    }}
                  >
                    Vídeo
                  </Button>
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              key={`modal-key`}
              show={verMapaModal}
              onClose={() => {
                setVerMapaModal(false);
              }}
              size="5xl"
              className="h-screen"
            >
              <Modal.Header>Mapa</Modal.Header>
              <Modal.Body>
                <div className="space-y-6">
                  <div className="grid lg:grid-cols-3 gap-3">
                    <div className={areaSelecionada?.imagem ? "" : ""}>
                      {areaSelecionada?.imagem && (
                        <>
                          <div
                            key="mapaAreaModal"
                            className="flex justify-center bg-gray-100"
                          >
                            <img
                              onClick={() => {
                                mostrarCapaArea(areaSelecionada?.imagem ?? "");
                              }}
                              src={areaSelecionada?.imagem}
                              className="rounded-md cursor-pointer"
                              style={{ maxWidth: "400px", width: "100%" }}
                            />
                          </div>
                        </>
                      )}

                      {areaSelecionada?.video &&
                        areaSelecionada?.video != "" && (
                          <>
                            <div className="w-full">
                              <Button
                                onClick={() => {
                                  mostrarVideo(areaSelecionada.video);
                                }}
                                className="bg-myred w-full rounded-md mt-3 font-bold text-2xl hover:bg-myred"
                              >
                                ASSISTIR VÍDEO
                              </Button>
                            </div>
                          </>
                        )}
                    </div>
                    <div className="md:lg-0 mt-5 w-full lg:col-span-2">
                      <p className="font-bold text-2xl ">
                        {areaSelecionada?.nome}
                      </p>
                      <p className="mb-4 text-gray-500 text-justify">
                        {areaSelecionada?.acesso}
                      </p>
                      <hr />
                      <p className="mt-5 mb-">STATUS:</p>
                      <hr />
                      <div className="flex justify-between mt-5">
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-green-500 w-7 h-7"></div>{" "}
                          Liberado
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-gray-500 w-7 h-7"></div>{" "}
                          Reservado
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-red-500 w-7 h-7"></div>{" "}
                          Indisponível
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {mesas?.map((mesa) => (
                      <>{mesaMapa(mesa)}</>
                    ))}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className="flex justify-end">
                <Button
                  color="light"
                  onClick={() => {
                    setVerMapaModal(false);
                  }}
                >
                  Fechar
                </Button>
                <Button
                  color="gray"
                  onClick={() => {
                    removerMesas();
                  }}
                >
                  Limpar
                </Button>
                <Button
                  className="bg-myblue"
                  onClick={() => {
                    setVerMapaModal(false);
                  }}
                >
                  Confirmar
                </Button>
              </Modal.Footer>
            </Modal>
          </LayoutHome>

          <ModalFull
            show={showModalFull}
            onClick={() => {
              setShowModalFull(false);
            }}
          >
            <div className="lg:w-2/4 w-full mx-3 text-white">
              <YouTubeView
                url={showVideo}
                width="100%"
                height={`${windowSize.height * 0.7}`}
              />
            </div>
          </ModalFull>

          <ModalFull
            show={showModalCapa}
            onClick={() => {
              setShowModalCapa(false);
            }}
          >
            <div className="lg:w-2/4 w-full mx-3 text-white ">
              <img
                src={imgCapaArea}
                alt=""
                style={{
                  maxHeight: tamanhoDaTela.height - 20,
                  margin: "0 auto",
                }}
              />
            </div>
          </ModalFull>

          <PixelGoogle
            script={props.evento.pixel_google_script ?? ""}
            noscript={props.evento.pixel_google_noscript ?? ""}
          />
        </>
      )}
      {!evento.id && (
        <LayoutHome marginBotton={60} qtdCart={qtdCart}>
          <div className="md:container mx-auto py-5 grid md:grid-cols-3 sm:px-10 mb-10">
            Evento não encontrado....
          </div>
          </LayoutHome>
      )}

    </>
  );
}

EventoDetail.layout = LayoutHome;
